import { ConcreteEncodable } from "./ConcreteEncodable";

import { AuthResponseImplEncoder } from "../../encoder/AuthResponseImplEncoder";

import * as CubiqTS from "../../index";
import { AuthResponse } from "../AuthResponse";

export class AuthResponseImpl extends ConcreteEncodable implements AuthResponse {
  public static enType: string = "com.bcdfx.security.AuthResponseImpl";

  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AuthResponseImplEncoder.Instance;
    this.setEncodableType(AuthResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return "AuthResponseImpl[" + "messageId=" + this.messageId + "]";
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
